export default __webpack_public_path__ + "/assets/raz_big.png";